import AuthService from '../config/auth';
import { showMailPrefModalIfExists } from "./../common/mailPreferences";

document.addEventListener('DOMContentLoaded', () => {
    const waitForGoogleIdentity = () => {
        if (window.google?.accounts?.id) {
            AuthService.setupGoogleOneTap();
            return;
        }
        setTimeout(waitForGoogleIdentity, 50);
    };

    waitForGoogleIdentity();

    showMailPrefModalIfExists();
});

